// libs
import React, { memo } from 'react';
import get from 'lodash/get';

// components
import WidgetCarousel from 'shared/components/AdPlatformWidgets/Desktop/components/GenericCarousel';
import WidgetTitle from 'shared/components/AdPlatformWidgets/components/WidgetTitle';

// context
import { useResponsiveContext } from 'shared/components/ResponsiveLoader/ResponsiveContext';

// constants
import { CAROUSEL_TYPES } from 'shared/components/AdPlatformWidgets/Desktop/components/GenericCarousel/constants';

// styles
import { Container, CarouselContainer } from './styles';
import { DWEB_MAX_WIDTH } from 'shared/styles/base';
import WidgetSubTitle from 'shared/components/AdPlatformWidgets/components/WidgetSubtitle';

// defs
import { ILandingPageWidgetData } from 'shared/components/AdPlatformWidgets/types';
import { WIDGET_TYPES } from 'shared/components/AdPlatformWidgets/constants';

interface ISlidingWidgetProps {
  widget: ILandingPageWidgetData;
}

function SlidingWidget({ widget }: ISlidingWidgetProps) {
  const { deviceWidth } = useResponsiveContext();

  let carouselType = CAROUSEL_TYPES.WIDGETS;
  let products = [];

  if (widget.widget_data.wtype === WIDGET_TYPES.RECOMMENDATION_WIDGET) {
    carouselType = CAROUSEL_TYPES.PRODUCTS;
    products = get(widget, 'widget_data.children', []);
  }

  const widgets = get(widget, 'widget_data');
  const containerWidth = deviceWidth > DWEB_MAX_WIDTH ? DWEB_MAX_WIDTH : deviceWidth;
  const title = get(widget, 'widget_data.parameters.title', '');
  const subtitle = get(widget, 'widget_data.parameters.sub_title', '');

  const inventoryName = get(widget, 'inventory_name', '');
  const titleAlignment = get(widget, 'widget_data.parameters.title_align_desktop', '');

  const marginTop = get(widget, 'widget_data.parameters.margin_top');

  return (
    <Container marginTop={marginTop}>
      {title && <WidgetTitle title={title} alignment={titleAlignment} />}

      {subtitle !== '' && <WidgetSubTitle title={subtitle} alignment={titleAlignment} />}

      <CarouselContainer>
        <WidgetCarousel
          carouselType={carouselType}
          widgets={widgets}
          products={products}
          containerWidth={containerWidth}
          inventoryName={inventoryName}
        />
      </CarouselContainer>
    </Container>
  );
}

export default memo(SlidingWidget);
